import { Calendar, Clock } from "lucide-react";

interface CompactDateTimePickerProps {
    dateValue: string;
    startTimeValue: string;
    endTimeValue: string;
    onDateChange: (value: string) => void;
    onStartTimeChange: (value: string) => void;
    onEndTimeChange: (value: string) => void;
    timezoneLabel: string;
}

const fieldClassName =
    "w-full px-4 py-4 bg-gray-50 border border-gray-200 rounded-xl outline-none focus:bg-white focus:border-[#4CE470] focus:ring-4 focus:ring-[#4CE470]/10 transition-all font-medium text-[#113A28]";

const CompactDateTimePicker = ({
    dateValue,
    startTimeValue,
    endTimeValue,
    onDateChange,
    onStartTimeChange,
    onEndTimeChange,
    timezoneLabel,
}: CompactDateTimePickerProps) => {
    return (
        <div className="space-y-4">
            <div>
                <label htmlFor="class-date" className="block mb-2 ml-1 text-xs font-bold tracking-wider text-gray-500 uppercase">
                    Start date
                    <span className="text-red-500 ml-1">*</span>
                </label>
                <div className="relative">
                    <Calendar size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" />
                    <input
                        id="class-date"
                        type="date"
                        value={dateValue}
                        onChange={(event) => onDateChange(event.target.value)}
                        className={`${fieldClassName} pl-11`}
                        required
                    />
                </div>
            </div>

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div>
                    <label htmlFor="class-start-time" className="block mb-2 ml-1 text-xs font-bold tracking-wider text-gray-500 uppercase">
                        Start time
                        <span className="text-red-500 ml-1">*</span>
                    </label>
                    <div className="relative">
                        <Clock size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" />
                        <input
                            id="class-start-time"
                            type="time"
                            value={startTimeValue}
                            onChange={(event) => onStartTimeChange(event.target.value)}
                            className={`${fieldClassName} pl-11`}
                            required
                        />
                    </div>
                </div>

                <div>
                    <label htmlFor="class-end-time" className="block mb-2 ml-1 text-xs font-bold tracking-wider text-gray-500 uppercase">
                        End time
                        <span className="text-red-500 ml-1">*</span>
                    </label>
                    <div className="relative">
                        <Clock size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" />
                        <input
                            id="class-end-time"
                            type="time"
                            value={endTimeValue}
                            onChange={(event) => onEndTimeChange(event.target.value)}
                            className={`${fieldClassName} pl-11`}
                            required
                        />
                    </div>
                </div>
            </div>

           
        </div>
    );
};

export default CompactDateTimePicker;
